import React from "react";
import Layout from "src/components/Layout";
import "./MaritimeMedicine.css";
import image from "../../images/3.png";
import InfoCard from "src/components/InfoCard";

const maritimemedicine: React.FC = () => {
  return (
    <Layout>
      <InfoCard title={"maritime medicine"} image={image}>
        <div className="maritime-details">
          <p>
            Seafarers are required to undergo medical examinations to reduce
            risks to other crew members and for the safe operation of the ship,
            as well as to safeguard their personal health and safety. The MLC,
            2006, and the STCW Convention, 1978, as amended, require a seafarer
            to hold a medical certificate, detail the information to be recorded
            and indicate certain specific aspects of fitness that need to be
            assessed. The Guidelines applied to seafarers in accordance with the
            requirements of the MLC, 2006, and the STCW Convention, 1978, as
            amended
          </p>
          <p>
            <strong></strong>
            These Guidelines have been developed in order to reduce the
            differences in the applica­tion of medical requirements and
            examination procedures and to ensure that the med­ical certificates
            which are issued to seafarers are a valid indicator of their medical
            fitness for the duties they will perform. Ultimately, the aim of the
            Guidelines is to contribute to health and safety at sea.
          </p>
          <p>
            <strong>DOTMEDICA</strong>
            <br></br>
            provides the following Seafarer Medical Certificates: •Personnel
            Service on Board Medical Fitness Certificate.<br></br> MLC 2006
            <br></br>
            •Vanutu Medical Fitness Certificate.<br></br>
            •Liberia Medical Fitness Certificate.<br></br>
            •Marshall Islands Medical Fitness Certificate.<br></br>
            •Panama Medical Fitness Certificate.<br></br>
            •PEME/ Annual Seafarer Medical for a wide range of companies.
          </p>
        </div>
      </InfoCard>
    </Layout>
  );
};

export default maritimemedicine;
